var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
function humanizeFilesize (bytes) {
    var k = 1000;
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

// shallow equal on all argument fields
// `fn` must take an object as it's only argument
function memo (fn) {
    var prevArgs = {}
    var prevRes = null

    return function (args) {
        var isEq = Object.keys(args).reduce((acc, k) => {
            return acc && prevArgs[k] === args[k]
        }, true)
        if (isEq) return prevRes

        prevArgs = args
        prevRes = fn(args)
        return prevRes
    }
}

export default {
    humanizeFilesize,
    memo
}

